/** Roles that can manage organization storage quotas and user caps. */
export function isStorageAdmin(role: string | undefined | null): boolean {
  if (!role) return false;
  const r = role.toLowerCase().replace(/-/g, '_');
  return r === 'admin' || r === 'super_admin' || r === 'superadmin';
}
